// ============================================================
// ActionIcon
// ------------------------------------------------------------
// ปุ่มไอคอนสี่เหลี่ยมในคอลัมน์ "จัดการ" ของตาราง (แก้ไข / ลบ / ดูรายละเอียด)
// เดิม markup ชุดนี้ copy อยู่ 22 หน้า หน้าละหลายจุด
//
// ใช้: <ActionIcon color="primary" icon={ICON.edit} onClick={...} className="mr-2" />
// สีที่ใช้อยู่: primary (แก้ไข), danger (ลบ), success (เปลี่ยนสัญญา), blue, warning
// ============================================================

import React from "react";

export default function ActionIcon({ color = "primary", icon, onClick, className = "", title }) {
  return (
    <label className={`wpx-24 hpx-24 bg-${color}-light rounded-1 d-flex align-items-center justify-content-center ${className}`} title={title}>
      <label className={`icon mx-2 text-${color} pointer`} onClick={onClick}>
        {icon}
      </label>
    </label>
  );
}
